module.exports = __webpack_public_path__ + "media/react/components/PatientBox/RentalStatus/assets/icon_border_house_white-c8c99db9197e8e2d2af7dfa5364cccb3.svg";